import { Store, createStore, withProps, select } from '@ngneat/elf';
import { Observable } from 'rxjs';

export interface SupportNumberProps {
  supportNumber: string | undefined;
}

export const supportNumberStore: Store = createStore(
  { name: 'supportNumber' },
  withProps<SupportNumberProps>({ supportNumber: undefined })
);

export const identity$: Observable<SupportNumberProps> =
  supportNumberStore.pipe(select((state) => state));

export const setSupportNumber = (supportNumber: string | undefined) => {
  supportNumberStore.update(() => ({ supportNumber }));
};
